import { Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";

import { useCctlByNameQuery } from "api/public/cctlDirectory/cctlDirectory.api";

import SidebarSection from "../../SidebarSection";

const LabSection = ({ labName }: { labName: string }) => {
  const { data: cctlInfo } = useCctlByNameQuery(labName ?? skipToken);
  if (!cctlInfo) return;

  return (
    <SidebarSection title="CC Testing Lab:">
      <Typography fontWeight="bold" fontSize={14}>
        Lab Name
      </Typography>
      <Typography variant="body1" component="address" ml={1} mb={1}>
        {cctlInfo.cctl_name} {cctlInfo.cctl_abbrv} <br />
        {cctlInfo.address_1} {cctlInfo.address_2} <br />
        {cctlInfo.city}, {cctlInfo.state} {cctlInfo.zip}
      </Typography>

      <Typography fontWeight="bold" fontSize={14}>
        Lab POC
      </Typography>
      <Typography variant="body1" ml={1} mb={1}>
        {cctlInfo.poc} <br />
        {cctlInfo.work_phone && `${cctlInfo.work_phone} (phone)`} <br />
        {cctlInfo.work_fax && `${cctlInfo.work_fax} (fax)`} <br />
        {cctlInfo.poc_email && cctlInfo.poc_email} <br />
      </Typography>

      {cctlInfo.nvlap_lab_code && (
        <>
          <Typography fontWeight="bold" fontSize={14}>
            NVLAP CODE:
          </Typography>
          <Typography variant="body1" ml={1} mb={1}>
            {cctlInfo.nvlap_lab_code}
          </Typography>
        </>
      )}

      {cctlInfo.lab_test_methods && (
        <>
          <Typography fontWeight="bold" fontSize={14}>
            TEST METHODS:
          </Typography>
          <Typography variant="body1" ml={1} mb={1}>
            {cctlInfo.lab_test_methods}
          </Typography>
        </>
      )}
    </SidebarSection>
  );
};
export default LabSection;
